import { getGlobalScope } from '@amplitude/analytics-core';
import * as constants from '../constants';
import { getCurrentPageViewId } from '../helpers';
export function fireViewportContentUpdated(_a) {
    var _b;
    var _c, _d, _e;
    var amplitude = _a.amplitude, scrollTracker = _a.scrollTracker, currentElementExposed = _a.currentElementExposed, elementExposedForPage = _a.elementExposedForPage, exposureTracker = _a.exposureTracker, isPageEnd = _a.isPageEnd, lastScroll = _a.lastScroll;
    var pageScrollMaxState = scrollTracker.getState();
    var globalScope = getGlobalScope();
    /* istanbul ignore next */
    var viewportWidth = (_c = globalScope === null || globalScope === void 0 ? void 0 : globalScope.innerWidth) !== null && _c !== void 0 ? _c : 0;
    /* istanbul ignore next */
    var viewportHeight = (_d = globalScope === null || globalScope === void 0 ? void 0 : globalScope.innerHeight) !== null && _d !== void 0 ? _d : 0;
    var eventProperties = (_b = {},
        _b[constants.AMPLITUDE_EVENT_PROP_PAGE_URL] = 
        /* istanbul ignore next */
        (_e = globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) === null || _e === void 0 ? void 0 : _e.href,
        _b[constants.AMPLITUDE_EVENT_PROP_MAX_PAGE_X] = pageScrollMaxState.maxX + viewportWidth,
        _b[constants.AMPLITUDE_EVENT_PROP_MAX_PAGE_Y] = pageScrollMaxState.maxY + viewportHeight,
        _b[constants.AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT] = viewportHeight,
        _b[constants.AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH] = viewportWidth,
        _b['[Amplitude] Element Exposed'] = Array.from(currentElementExposed),
        _b);
    var pageViewId = getCurrentPageViewId();
    if (pageViewId) {
        eventProperties[constants.AMPLITUDE_EVENT_PROP_PAGE_VIEW_ID] = pageViewId;
    }
    // If elements exposed is empty and max scroll is same as last event, don't track
    if (currentElementExposed.size === 0 &&
        pageScrollMaxState.maxX === lastScroll.maxX &&
        pageScrollMaxState.maxY === lastScroll.maxY) {
        if (isPageEnd) {
            scrollTracker.reset();
            elementExposedForPage.clear();
            exposureTracker === null || exposureTracker === void 0 ? void 0 : exposureTracker.reset();
        }
        return;
    }
    /* istanbul ignore next */
    amplitude === null || amplitude === void 0 ? void 0 : amplitude.track('[Amplitude] Viewport Content Updated', eventProperties);
    lastScroll.maxX = pageScrollMaxState.maxX;
    lastScroll.maxY = pageScrollMaxState.maxY;
    // Clear current batch
    currentElementExposed.clear();
    if (isPageEnd) {
        // Reset state for next page view
        scrollTracker.reset();
        elementExposedForPage.clear();
        exposureTracker === null || exposureTracker === void 0 ? void 0 : exposureTracker.reset();
    }
}
export function onExposure(elementPath, elementExposedForPage, currentElementExposed, fireViewportContentUpdatedCallback) {
    if (elementExposedForPage.has(elementPath)) {
        return;
    }
    elementExposedForPage.add(elementPath);
    currentElementExposed.add(elementPath);
    // Check if current set size exceeds 18k chars
    var exposedArray = Array.from(currentElementExposed);
    var exposedString = JSON.stringify(exposedArray);
    if (exposedString.length >= constants.MAX_ELEMENT_EXPOSED_STR_LENGTH) {
        fireViewportContentUpdatedCallback(false);
    }
}
